import axios from 'axios';
import { API_ADDRESS } from '../services/api/address';

const stripTokenFromUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    const newSearch = url.searchParams.toString();
    const newUrl = `${url.pathname}${newSearch ? `?${newSearch}` : ''}${url.hash}`;
    window.history.replaceState({}, '', newUrl);
};

const normalizeMeetingsToken = token => {
    if (!token || token === 'null' || token === 'Bearer null') {
        return null;
    }

    return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

export const authFromQuery = async () => {
    const params = new URLSearchParams(window.location.search);
    const porosysToken = params.get('token');

    if (!porosysToken) {
        return { status: 'skipped' };
    }

    stripTokenFromUrl();

    try {
        const authorization = porosysToken.startsWith('Bearer ') ? porosysToken : porosysToken;

        const response = await axios.post(
            `${API_ADDRESS}/users/loginx`,
            {},
            {
                headers: {
                    Authorization: authorization,
                },
                timeout: 15000,
            }
        );

        const meetingsToken = normalizeMeetingsToken(response.data?.data?.token);

        if (!meetingsToken) {
            return {
                status: 'failed',
                message: 'حساب کاربری شما در سیستم جلسات یافت نشد یا امکان ورود خودکار وجود ندارد.',
            };
        }

        localStorage.setItem('token', meetingsToken);
        sessionStorage.setItem('porosysToken', porosysToken);

        return { status: 'success' };
    } catch (error) {
        return {
            status: 'failed',
            message: 'خطا در برقراری ارتباط با سرور جلسات. لطفا دوباره تلاش کنید.',
        };
    }
};
